import { ref, onMounted, onUnmounted } from 'vue';

const useClickOutside = (elementRefs: any, callback?: ()=>void) => {
  const isOutside = ref(false);

  const handleClick = (event: Event) => {
    if (!Array.isArray(elementRefs) && elementRefs.value && !elementRefs.value.contains(event.target)) {
      isOutside.value = true;
      callback?.();
    } else if (Array.isArray(elementRefs)) {
      isOutside.value = elementRefs.every(
        (elementRef) => elementRef.value && !elementRef.value.contains(event.target),
      );
      if (isOutside.value) {
        callback?.();
      }
    } else {
      isOutside.value = false;
    }
  };

  onMounted(() => {
    document.addEventListener('mousedown', handleClick);
    document.addEventListener('touchstart', handleClick);
  });

  onUnmounted(() => {
    document.removeEventListener('mousedown', handleClick);
    document.removeEventListener('touchstart', handleClick);
  });

  return isOutside;
};

export default useClickOutside;
